module.exports = __webpack_public_path__ + "static/media/Note.d531faf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/Note.svg
// module id = 264
// module chunks = 0